import IncreaseDecrease from './increaseDecrease';
import DebitCredit from './debitCredit';
import DebitCredit2 from './debitCredit2';
import AccountsImpacted from './accountsImpacted';
import IncomeStatementImpact from './incomeStatementImpact';
import AllTypes from './allTypes';

const levelComponents = {
  'increase-decrease': IncreaseDecrease,
  'debit-credit': DebitCredit,
  'debit-credit2': DebitCredit2,
  'accounts-impacted': AccountsImpacted,
  'income-statement-impact': IncomeStatementImpact,
  'all-types': AllTypes
};

export default function BalancedEquation({
  levelType,
  onComplete,
  numberOfAttempts,
  businessType
}) {
  const Component = levelComponents[levelType] || IncreaseDecrease;

  return (
    <Component
      onComplete={onComplete}
      numberOfAttempts={numberOfAttempts}
      businessType={businessType}
    />
  );
}